<template>
  <Flipbook 
    class="flipbook"
    :pages="pages"
    :pagesHiRes="pagesHiRes"
    :startPage="pageNum"
    v-slot="flipbook"
    ref="flipbook"
    @flip-left-start="onFlipLeftStart"
    @flip-left-end="onFlipLeftEnd"
    @flip-right-start="onFlipRightStart"
    @flip-right-end="onFlipRightEnd"
    >
    <div class="action-bar">
      <v-btn
          icon
          dark
          class="btn left"
          :class="{ disabled: !flipbook.canFlipLeft }"
          @click="flipbook.flipLeft"
          > <v-icon>mdi mdi-chevron-left</v-icon> </v-btn>
      <v-btn
          icon
          dark
          class="btn plus"
          :class="{ disabled: !flipbook.canZoomIn }"
          @click="flipbook.zoomIn"
      >  <v-icon>mdi mdi-plus</v-icon>  </v-btn>
      <span class="page-num">
          <span class="text-capitalize">{{$t('bookReading.page')}}</span> 
          {{ flipbook.page }} {{$t('bookReading.of')}} {{ flipbook.numPages }}
      </span>
      <v-btn
          icon
          dark
          class="btn minus"
          :class="{ disabled: !flipbook.canZoomOut }"
          @click="flipbook.zoomOut"
          >  <v-icon>mdi mdi-minus</v-icon>  </v-btn>
      <v-btn
          icon
          dark
          class="btn right"
          :class="{ disabled: !flipbook.canFlipRight }"
          @click="flipbook.flipRight"
      >  <v-icon>mdi mdi-chevron-right</v-icon> </v-btn>
    </div>
  </Flipbook>
</template>

<script>
import Flipbook from "flipbook-vue"
import BookService from '@/services/book'

export default {
  components: {
    Flipbook
  },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  data() {
      return {
        pages: [],
        pagesHiRes: [],
        hasMouse: true,
        pageNum: null,
        magazineLoaded: false,
    }
  },
  async mounted() {

    window.addEventListener('keydown', function(ev) {
      const flipbook = this.$refs.flipbook;
      if (!flipbook) return;

      if (ev.key == 'ArrowLeft' && flipbook.canFlipLeft) {
          flipbook.flipLeft();
      }

      if (ev.key == 'ArrowRight' && flipbook.canFlipRight) {
          flipbook.flipRight();
      }
    }.bind(this)); 

    window.addEventListener('hashchange', this.setPageFromHash)
    this.setPageFromHash()
  },
  methods: {
    onFlipLeftStart(page) { console.log('flip-left-start', page) },
    onFlipLeftEnd(page) {
        window.location.hash = '#' + page
    },
    onFlipRightStart(page) { console.log('flip-right-start', page) },
    onFlipRightEnd(page) {
        window.location.hash = '#' + page
    },
    setPageFromHash() {
        const n = parseInt(window.location.hash.slice(1), 10)
        if (isFinite(n)) this.pageNum = n
    },
    extractImagesFromHTML(html) {
      // Create a new DOM parser
      const parser = new DOMParser();

      // Parse the HTML string
      const doc = parser.parseFromString(html, 'text/html');

      // Find all image elements
      const images = doc.querySelectorAll('img');

      // Map over the images and extract the src attribute
      const srcs = Array.from(images).map(img => img.src);

      return srcs;
    },
    async loadMagazine(resource) {
      if (resource === '') return
      const url = `${process.env.VUE_APP_BOOK_DATA_URL}${resource}/c_01.html`
      const response = await BookService.getChapterContentHTML(url).catch((e) => console.error(e))
      const htmlContent = await response.text()
      const images = this.extractImagesFromHTML(htmlContent)
      this.pages = [null,...images]
      this.pagesHiRes = [null,...images]
    }
  },
  watch: {
    resource: {
      handler: function (val, oldVal) {
        this.loadMagazine(val)
      },
      immediate: true
    }
  } 
}
</script>

<style lang="scss">
.flipbook {
  // width: 95vw;
  height: 95vh;
  @media screen and (max-width: 960px) {
    height: 90vh;
  }
}
.flipbook .bounding-box {
  box-shadow: 0 0 20px #000;
  left: 0;
}
::v-deep .flipbook .viewport .container {
  max-width: 100%;
}

.action-bar {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-bar .btn {
  font-size: 30px;
  background: #999;
}
.action-bar .btn:not(:first-child) {
  margin-left: 10px;
}

.has-mouse .action-bar .btn:hover {
  background: #ccc;
  filter: drop-shadow(1px 1px 5px #000);
  cursor: pointer;
}

.action-bar .btn:active {
  background: #999;
}

.action-bar .btn.disabled {
  background: #ccc;
  pointer-events: none;
}

.action-bar .page-num {
  font-size: 12px;
  margin-left: 10px;
}

.flipbook .viewport {
  width: 90vw !important;
  height: calc(100vh - 90px) !important;
  @media screen and (max-width: 960px) {
    height: calc(100vh - 200px) !important;
  }
  @media screen and (max-width: 600px) {
    height: calc(100vh - 170px) !important;
  }
  
  .container {
    @media screen and (min-width: 960px) {
      position: relative;
      left: -10%;
    }
    @media screen and (min-width: 1267px) {
      position: relative;
      left: 0%;
    }
    @media screen and (min-width: 1367px) {
      position: relative;
      left: -10%;
    }
  }
  
}

</style>